import Backbone from 'backbone'

var ClipAccessLog = Backbone.Model.extend({
  urlRoot: '/api/v3/clip_access_logs/'
});

export default ClipAccessLog;

